import { Wand2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const Header = () => {
  return (
    <header className="border-b bg-white/50 backdrop-blur-sm fixed top-0 w-full z-50">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <Wand2 className="h-6 w-6 text-sage-600" />
          <span className="font-semibold text-xl text-sage-800">AltTextWizard</span>
        </div>
        <Link to="/auth">
          <Button variant="default" size="sm">
            Get Started
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </Link>
      </div>
    </header>
  );
};